import { Router, ActivatedRoute } from '@angular/router';
import { CUSTOMER_COMP } from './../../customer/customer.const';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {
  FETCH_DELIVERYS_REQUESTED,
  FETCH_DELIVERYS_SUCCEEDED,
  SORT_DELIVERYS_REQUESTED,
  SORT_DELIVERYS_SUCCEEDED,
  UPDATE_DELIVERY_FILTER,
  DELIVER_PRODUCT_REQUESTED, DELIVER_PRODUCT_SUCCEEDED,
  REMIND_DRIVER_ON_HIS_WAY_REQUESTED,
  REMIND_DRIVER_ON_HIS_WAY_SUCCEEDED, DELIVER_PRODUCT_FAILED
} from './list.actions';
import * as _ from 'lodash';
import {UtilityService} from "../../../common/services/utility/utility.service";
import {FETCH_ORDER_DETAIL_REQUESTED} from "../../order/detail/detail.actions";
import {NotificationService} from "../../../common/services/notification/notification.service";
import {DOWNLOAD_REQUESTED} from "../../product/list/list.actions";
import store from "../../../store/store.module";

function* fetchDeliverys(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.delivery.get(action.data.pagination, action.data.sorts, action.data.filters).toPromise();
    AppInjector.get(UtilityService).reset();
    yield put({ type: FETCH_DELIVERYS_SUCCEEDED, data: results.items, pagination: results.pagination, defaultSelection: action.data.defaultSelection, untouched: action.data.untouched });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchDeliverysRequest() {
  yield takeEvery(FETCH_DELIVERYS_REQUESTED, fetchDeliverys);
}

function* remindDriverOnHisWay(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.delivery.remindDriverOnHisWay(action.data).toPromise();
    AppInjector.get(NotificationService).show('success', 'Message Sent', 5000);
    yield put({ type: REMIND_DRIVER_ON_HIS_WAY_SUCCEEDED });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchRemindDriverOnHisWay() {
  yield takeEvery(REMIND_DRIVER_ON_HIS_WAY_REQUESTED, remindDriverOnHisWay);
}

function* sortDeliverys(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.delivery.sort(action.data).toPromise();
    yield put({ type: SORT_DELIVERYS_SUCCEEDED, data: results.items, total: results.total });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSortDeliverysRequest() {
  yield takeEvery(SORT_DELIVERYS_REQUESTED, sortDeliverys);
}

function* filterDelivery(action) {
  try {
    const activatedRoute = AppInjector.get(ActivatedRoute);
    const router = AppInjector.get(Router);
    const url = activatedRoute.snapshot.url;
    let queryParams = _.assign({}, activatedRoute.snapshot.queryParams, { page: 1 });
    let constraints = {};
    queryParams = _.assign(queryParams, { constraints: JSON.stringify(constraints) });
    router.navigate([url], { queryParams: queryParams });
  } catch (e) {}
}

function* watchDeliveryFilterRequest() {
  yield takeEvery(UPDATE_DELIVERY_FILTER, filterDelivery);
}

function* changeMultipleProductOrderStatus(action) {
  const api = AppInjector.get(ApiService);
  try {
    yield api.delivery.bulkUpdate(action.data).toPromise();
    if (action.download) {
      yield put({ type: DOWNLOAD_REQUESTED, data: action.download});
    }
    yield put({ type: DELIVER_PRODUCT_SUCCEEDED });
    AppInjector.get(Router).navigate(['delivery/list'], { queryParams: {
        filters: JSON.stringify(action.fetchData.filters)
      }});
    AppInjector.get(NotificationService).show('success', 'Delivery changed', 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
    yield put({ type: DELIVER_PRODUCT_FAILED });
  }
}

function* waitChangeMultiProductOrderStatusRequest() {
  yield takeEvery(DELIVER_PRODUCT_REQUESTED, changeMultipleProductOrderStatus);
}

export default [watchDeliveryFilterRequest, watchFetchDeliverysRequest, watchSortDeliverysRequest, waitChangeMultiProductOrderStatusRequest, watchRemindDriverOnHisWay];
